export type IContentType = "texts" | "docs" | "defaultContent";
export const LANGUAGE_VALUES = ["en", "fi", "sv", "de", "es", "zh"] as const;
export type ILanguage = (typeof LANGUAGE_VALUES)[number];
export const LANGUAGES: ILanguage[] = [...LANGUAGE_VALUES];
export const AI_LANGUAGES: ILanguage[] = ["fi", "sv", "de", "zh"];
export const REFERENCE_LANGUAGE: ILanguage = "en";
export const PAGE_SIZE = 30;
export const LANGUAGE_NAMES: Record<ILanguage, string> = {
    en: "English",
    fi: "Finnish",
    sv: "Swedish",
    de: "German",
    es: "Spanish",
    zh: "Chinese",
};
